/* block */
/* FW: Email Us chat option -> mailto (must register before GHL loader's window-capture swallower) */
(function(){
  window.addEventListener('click',function(e){
    var path=e.composedPath?e.composedPath():[];
    for(var i=0;i<path.length;i++){
      var n=path[i];
      if(n&&n.classList&&n.classList.contains('chat-selection-button')){
        var t=(n.textContent||'').toLowerCase();
        if(t.indexOf('email')>-1||t.indexOf('sms')>-1){
          e.preventDefault();e.stopImmediatePropagation();
          window.location.href='mailto:info@furnitureworld.co.nz';
        }
        else if(t.indexOf('voice')>-1||t.indexOf('jenny')>-1||t.indexOf('09 873')>-1||t.indexOf('call us')>-1){
          e.preventDefault();e.stopImmediatePropagation();
          window.location.href='tel:+6498736364';
        }
        return;
      }
    }
  }, true);
})();

/* block */
/* FW: relabel Voice AI tile -> phone call via 09 line; Live Chat label update 2026-06-28 */
(function(){
  function deepRelabel(root){
    root.querySelectorAll('.chat-selection-button').forEach(function(b){
      var w=document.createTreeWalker(b,NodeFilter.SHOW_TEXT),n;
      while(n=w.nextNode()){
        if(/jenny|\(voice\)/i.test(n.nodeValue)){n.nodeValue='Call Us (09 873 6364)';}
        if(/Live Chat with Our Team|Chat with AI Assistant/i.test(n.nodeValue)){n.nodeValue=n.nodeValue.replace(/Live Chat with Our Team|Chat with AI Assistant/ig,'Live Chat');}
      }
      root.querySelectorAll('.chat-selection-button').forEach(function(b){
        var t=(b.textContent||'').replace(/\s+/g,' ').trim();
        if(/Live Chat/i.test(t)){
          b.setAttribute('aria-label','Live Chat');
          b.setAttribute('data-fw-ai-chat-button','true');
        }
      });
    });
    root.querySelectorAll('*').forEach(function(el){if(el.shadowRoot)deepRelabel(el.shadowRoot);});
  }
  setInterval(function(){
    var cw=document.querySelector('chat-widget');
    if(cw&&cw.shadowRoot)deepRelabel(cw.shadowRoot);
  },800);
})();
